import { CampaignFlatRateBlock, CampaignPackagesBlock, HtmlBlock } from '@/cms/definitions/content-types';
import BuyInsuranceSettings from '../BuyInsuranceSettings';
import { exception } from '@/appinsights/logging/ApplicationInsightLog';

export class TravelSettings extends BuyInsuranceSettings {
	public segmentedProductPropertyPopover: string;
	public segmentedProductPropertiesLabel: string;
	public familyMemberInfo: string;
	public cancelSum: number; // afbestillingssum 30000 || 60000
	public cancelSumId = '3';

	public constructor(settingsBlock: HtmlBlock, campaignBlocks: Array<CampaignFlatRateBlock | CampaignPackagesBlock>) {
		super(settingsBlock, campaignBlocks);
		this.loadTravelSettings();
	}

	/**
	 * load settings from CMS if present
	 */
	private loadTravelSettings() {
		try {
			let setting: string;
			const settingsArr = this.settingsBlock.markup.split('$');
			settingsArr.forEach((setting_) => {
				setting = setting_.toLowerCase().trim();
				if (setting.includes('___')) {
					// ignore setting
				} else if (setting.startsWith('segmentedproductpropertypopover=')) {
					this.segmentedProductPropertyPopover = this.getSettingsValue(setting_);
				} else if (setting.startsWith('segmentedproductpropertieslabel=')) {
					this.segmentedProductPropertiesLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('familymemberinfo=')) {
					this.familyMemberInfo = this.getSettingsValue(setting_);
				} else if (setting.startsWith('cancelsum=')) {
					this.cancelSum = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('cancelsumid=')) {
					this.cancelSumId = this.getSettingsValue(setting_);
				}
			});
		} catch (e) {
			exception(e);
		}
	}
}
